import { render, staticRenderFns } from "./StampaEtichetteComponent.vue?vue&type=template&id=42b0ba2f&scoped=true&"
import script from "./StampaEtichetteComponent.vue?vue&type=script&lang=js&"
export * from "./StampaEtichetteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b0ba2f",
  null
  
)

export default component.exports